import React from 'react';
import PropTypes from 'prop-types';
import { Link } from './ActionElement';
import { restartPageView } from '../../common/utils';
import withLocalization from '../higherOrderComponents/withLocalization';

const SiteLogo = ({ translate, adjustImages = true, wrapperClasses: passedClasses = [], logoColor = 'white' }) => {
  const wrapperClasses = [...passedClasses];
  wrapperClasses.push('site-logo-link');

  if (adjustImages) {
    wrapperClasses.push('adjust-image-sizes');
  }

  const url = 'https://static.wannasport.dk/vector/';
  const imageNames = ['logo', 'logotype'];

  return (
    <Link
      to='/'
      type='navLink'
      className={wrapperClasses.join(' ')}
      title={translate('link-homePage-title')}
      onClick={restartPageView}
    >
      {imageNames.map(name => (
        <img
          key={`image-site-${name}`}
          className={`site-${name}`}
          src={`${url}${name}-${logoColor}${name === 'logotype' && adjustImages ? '-adjustedHeight' : ''}.svg`}
          alt={translate(`image-${name}-alt`)}
        />
      ))}
    </Link>
  );
};

SiteLogo.propTypes = {
  logoColor: PropTypes.oneOf([
    'white',
    'red',
    'lightgreen',
    'green',
    'deepblue',
    'black'
  ]),
  wrapperClasses: PropTypes.arrayOf(PropTypes.string),
  adjustImages: PropTypes.bool
};

export default withLocalization(SiteLogo, 'elements/siteLogo');